'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNextOpenDay = exports.isOpen = exports.getHoursMinutes = exports.getTimeNow = undefined;
var _date = require('@marmalade/date');
var _constants = require('./constants');

// Returns the time as a whole number - 9:45 = 9.75 / 14:30 = 14.5
var getTimeNow = exports.getTimeNow = function getTimeNow(date) {
  return date.getHours() + date.getMinutes() / 60;
};

// Return an object with hours, minutes for a whole number time - 19.5 = { hours: 19, minutes: 30 }
var getHoursMinutes = exports.getHoursMinutes = function getHoursMinutes(time) {
  var hours = Math.floor(time);
  var minutes = Math.round((time - hours) * 60);
  return {
    hours: hours,
    minutes: minutes
  };
};
var isOpen = exports.isOpen = function isOpen() {
  var openingHours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.openingHours;
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var day = (0, _date.getNamedDay)(date.getDay()).toLowerCase();
  if (openingHours[day] === 'closed') {
    return false;
  }
  var now = getTimeNow(date);
  return now >= openingHours[day].open && now < openingHours[day].close;
};

/*
    findNextOpenDay

    return {
        name: string - "today", "tomorrow" or day of the week "Monday", "Tuesday", etc...
                       on sundays name is "Monday" over "tomorrow"
        open: number,
        close: number
    } or undefined
*/
var findNextOpenDay = exports.findNextOpenDay = function findNextOpenDay() {
  var openingHours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.openingHours;
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var currentDayOfTheWeek = date.getDay();
  var currentDayName = (0, _date.getNamedDay)(currentDayOfTheWeek).toLowerCase();
  var currentDayOpeningHours = openingHours[currentDayName];

  // If today's open hasn't happened yet.
  if (currentDayOpeningHours && currentDayOpeningHours !== 'closed' && getTimeNow(date) < currentDayOpeningHours.open) {
    return Object.assign({
      name: 'today'
    }, currentDayOpeningHours);
  }

  // Check the next 6 days
  for (var daysOffset = 1; daysOffset < 7; daysOffset++) {
    var dayOfTheWeek = (currentDayOfTheWeek + daysOffset) % 7;
    var dayName = (0, _date.getNamedDay)(dayOfTheWeek);
    var dayOpeningHours = openingHours[dayName.toLowerCase()];
    if (dayOpeningHours && dayOpeningHours !== 'closed') {
      return Object.assign({
        name: daysOffset === 1 && dayName !== 'Monday' ? 'tomorrow' : dayName
      }, dayOpeningHours);
    }
  }
  return undefined;
};